import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;
export const LoginAdmin = async ({ payload }) => {
  try {
    const response = await apiCall({
      endpoint: "api/auth/login",
      method: "POST",
      payload: payload,
    });

    if (response?.success) {
      localStorage.setItem(
        "user_cred",
        JSON.stringify({
          token: response.token,
          roleType: response.roleType,
        })
      );
    }

  } catch (error) {
    localStorage.removeItem("user_cred");
    throw error;
  }
};

export const InitMfaLogin = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/auth/init-mfa-login",
      method: "POST",
      payload,
      skipAuth: true,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const SendOTP = async (payload) => {
  try {
    const otpResponse = await apiCall({
      endpoint: "api/auth/send-otp",
      method: "POST",
      payload: payload,
      skipAuth: true,
    });

    return otpResponse;
  } catch (error) {
    console.error("Error in OTP flow:", error);
    throw error;
  }
};

export const VerifyOTP = async (payload) => {
  try {
    const endpoint = `api/auth/verify-otp`;
    const response = await apiCall({
      endpoint: endpoint,
      method: "POST",
      payload: payload,
    });
    if (response?.success) {
      localStorage.setItem(
        "user_cred",
        JSON.stringify({
          token: response.token,
          roleType: response.roleType,
        })
      );
    }
    return response;
  } catch (error) {
    console.error("Error verifying OTP:", error);
    throw error;
  }
};

export const initForgotPassword = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/auth/init-forgot-password",
      method: "POST",
      payload: payload,
      skipAuth: true,
    });
    return response;
  } catch (error) {
    console.error("Error in forgot password flow:", error);
    throw error;
  }
}

export const ForgotSendOTP = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/auth/send-forgot-otp",
      method: "POST",
      payload: payload,
      skipAuth: true,
    });
    return response;
  } catch (error) {
    console.error("Error in OTP flow:", error);
    throw error;
  }
}

export const ForgotVerifyOTP = async (payload) => {
  try {
    const endpoint = `api/auth/check-forgot-otp`;
    const response = await apiCall({
      endpoint: endpoint,
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    console.error("Error verifying OTP:", error);
    throw error;
  }
};

export const ResetPassword = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/auth/reset-password",
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    console.error("Error resetting password:", error);
    throw error;
  }
}


export const apiCall = async ({ endpoint, method = "GET", payload = null }) => {
  try {
    const user = JSON.parse(localStorage.getItem("user_cred"));
    const headers = user?.token
      ? { Authorization: `Bearer ${user.token}` }
      : {};

    if (payload && !(payload instanceof FormData)) {
      headers["Content-Type"] = "application/json";
    }

    const config = {
      url: `${baseURL}/${endpoint}`,
      method: method.toUpperCase(),
      headers,
      ...(payload && { data: payload }),
    };

    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      localStorage.removeItem("user_cred");
    }
    throw error;
  }
};
